import {HasId} from "../../helpers/crud/edit/HasId";

export class colorPalette implements HasId {
    id: number;
    first: string;
    second: string;
    third: string;
    fourth: string;
    fifth: string;
    sixth: string;
    organizationId?: number;
    isDefault: boolean;
}